import { Entity } from './entity';
import { environment } from '../../environments/environment';
import { Position } from './position';
import { SubAssignment } from './sub-assignment';

export class SearchResult extends Entity {

    pageId: number;
    text: string;
    position: Position;
    chapter: number;
    teaser: string;
    preview: string;
    active: boolean;
    subAssignments?: Array<SubAssignment> = [];

    getEndpointName(): string {
        return environment.endpointUrls.pageSearch;
    }
}
